export enum SupervisorAddTaskColumns {
  phase,
  task,
  description,
  isAdded,
}
